import React from 'react';
import styled from 'styled-components';
import { WorkforceCenterMap } from 'apps/journey/components/workforce-center-map';
import withAuth from 'util/hoc/with-auth';
import QueryContext from 'context/query-context';
import Query from 'library/util/query';
import PublicQuery from 'library/util/public-query';
import { bool } from 'prop-types';
import { jsonToInputParams } from 'library/util/graph';

const StyledWorkforceCenters = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
`;

const submitWorkforceCenterIds = async ({ workforceCenterIds }) => {
  const params = {
    organization_ids: workforceCenterIds.map((id) => Number(id)),
  };
  return await Query(`
  mutation {
    update_user_organizations(${jsonToInputParams(params)}) {
      success
      errors
    }
  }`);
};

const WorkforceCenters = ({ authentication: { authorized } }) => {
  const ContextQuery = authorized ? Query : PublicQuery;

  const handleSavedWorkforceCenter = async (workforceCenterIds = []) => {
    if (!authorized || !workforceCenterIds.length) return;
    await submitWorkforceCenterIds({ workforceCenterIds });
  };

  return (
    <QueryContext.Provider value={{ query: ContextQuery, authorized: authorized }}>
      <StyledWorkforceCenters>
        <WorkforceCenterMap
          handleUpdateFavoritedCallback={handleSavedWorkforceCenter}
        />
      </StyledWorkforceCenters>
    </QueryContext.Provider>
  );
};

WorkforceCenters.propTypes = {
  authentication: {
    authorized: bool,
  },
};

export default withAuth(WorkforceCenters);
